import { buildModelManager } from "../builder.js";
const DefaultTradeCategorySelection = {
  __typename: true,
  id: true,
  active: true,
  aliases: true,
  createdAt: true,
  label: true,
  mcc: true,
  parentId: true,
  profileTradeType: true,
  slug: true,
  updatedAt: true
};
const modelApiIdentifier = "tradeCategory";
const pluralModelApiIdentifier = "tradeCategories";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySlug",
    findByField: "slug",
    findByVariableName: "slug",
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySlug",
    findByField: "slug",
    findByVariableName: "slug",
    modelApiIdentifier,
    defaultSelection: DefaultTradeCategorySelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createTradeCategory",
    operationReturnType: "CreateTradeCategory",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      tradeCategory: { required: false, type: "CreateTradeCategoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultTradeCategorySelection
  },
  {
    type: "action",
    operationName: "bulkCreateTradeCategories",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateTradeCategoriesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultTradeCategorySelection
  },
  {
    type: "action",
    operationName: "updateTradeCategory",
    operationReturnType: "UpdateTradeCategory",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      tradeCategory: { required: false, type: "UpdateTradeCategoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultTradeCategorySelection
  },
  {
    type: "action",
    operationName: "bulkUpdateTradeCategories",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateTradeCategoriesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultTradeCategorySelection
  },
  {
    type: "action",
    operationName: "deleteTradeCategory",
    operationReturnType: "DeleteTradeCategory",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteTradeCategories",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertTradeCategory",
    operationReturnType: "UpsertTradeCategory",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      tradeCategory: { required: false, type: "UpsertTradeCategoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateTradeCategoryResult": { hasReturnType: false },
      "... on UpdateTradeCategoryResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultTradeCategorySelection
  },
  {
    type: "action",
    operationName: "bulkUpsertTradeCategories",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertTradeCategoriesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultTradeCategorySelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "tradeCategoryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const TradeCategoryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultTradeCategorySelection,
  operations
);
export {
  DefaultTradeCategorySelection,
  TradeCategoryManager
};
//# sourceMappingURL=TradeCategory.js.map
